angular.module('impactx.budget').directive('ixBudgetReadonlyBasket', function () {
    return {
        scope: {
            budget: '=',
            budgetNetWkTranslation: "@"
        },
        restrict: 'E',
                templateUrl: 'modules/budget/templates/budgetreadonlybasket.tmpl.html'
    };
});